// extracted by mini-css-extract-plugin
export default {"preview":"table-module__preview__SdNMx","noBorder":"table-module__noBorder__WFkgS","header":"table-module__header__h1Vsy","fixed":"table-module__fixed__gpQH6"};